import { parseAsArrayOf, parseAsString } from 'nuqs';

const arrayOfStrings = parseAsArrayOf(parseAsString);

export enum ReportFilterKey {
  Tags = 'tags',
  Sites = 'sites',
  TimePeriods = 'timePeriods',
  Customers = 'customers',
  GoodsType = 'goodsType',
}

// Values must match keys in commonFilterParsers so useDataTableQueryState can read them
export enum ReportFilterColumn {
  Tags = 'tag',
  Sites = 'site',
  TimePeriods = 'period',
  Customers = 'customer',
  GoodsType = 'type',
}

export const reportFilters = {
  [ReportFilterKey.Tags]: {
    column: ReportFilterColumn.Tags,
    apiKey: 'tags',
    type: arrayOfStrings,
  },
  [ReportFilterKey.Sites]: {
    column: ReportFilterColumn.Sites,
    apiKey: 'sites',
    type: arrayOfStrings,
  },
  [ReportFilterKey.TimePeriods]: {
    column: ReportFilterColumn.TimePeriods,
    apiKey: 'time_periods',
    type: arrayOfStrings,
  },
  [ReportFilterKey.Customers]: {
    column: ReportFilterColumn.Customers,
    apiKey: 'customers',
    type: arrayOfStrings,
  },
  [ReportFilterKey.GoodsType]: {
    column: ReportFilterColumn.GoodsType,
    apiKey: 'goods_type',
    type: arrayOfStrings,
  },
} as const;

export type ReportFilterOption = keyof typeof reportFilters;

// Only the filter keys whose options come from the API response (not hardcoded)
export const reportFilterKeys = [
  ReportFilterKey.Tags,
  ReportFilterKey.Sites,
  ReportFilterKey.TimePeriods,
  ReportFilterKey.Customers,
] as const;
